import { STATUS, PDF_STATUS } from 'chameleon-src/constants/assessmentStatus';

export const assignmentStatusesOptions = [
  {
    label: 'Active',
    value: STATUS.ASSIGNED,
  },
  {
    label: 'Ready to Score',
    value: STATUS.READY_TO_SCORE,
  },
  {
    label: 'Complete',
    value: STATUS.COMPLETED,
  },
];

export const assessmentsStatusesOptions = [
  {
    label: 'Assigned',
    value: STATUS.ASSIGNED_RESOURCES,
  },
  {
    label: 'Unassigned',
    value: STATUS.UNASSIGNED,
  },
];

export const assessmentsPdfsStatusesOptions = [
  {
    label: 'Always Visible',
    value: PDF_STATUS.ALWAYS_VISIBLE,
  },
  {
    label: 'Shared',
    value: PDF_STATUS.SHARED,
  },
  {
    label: 'Not Shared',
    value: PDF_STATUS.NOT_SHARED,
  },
];
